import {useState, useEffect, useMemo} from 'react';

import {remoteConfigService} from '../services/remoteConfig';

export const useRemoteConfig = (keys = []) => {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const keysString = useMemo(
    () => JSON.stringify(keys.map((k) => ({key: k.key, type: k.type}))),
    [keys]
  );

  useEffect(() => {
    let isMounted = true;

    const loadRemoteConfig = async () => {
      try {
        await remoteConfigService.initialize();

        if (!isMounted) return;

        const parsedKeys = JSON.parse(keysString);
        const newConfig = {};

        parsedKeys.forEach(({key, type = 'string'}) => {
          switch (type) {
            case 'boolean':
              newConfig[key] = remoteConfigService.getBoolean(key);
              break;
            case 'number':
              newConfig[key] = remoteConfigService.getNumber(key);
              break;
            case 'json':
              newConfig[key] = remoteConfigService.getJSON(key);
              break;
            default:
              newConfig[key] = remoteConfigService.getString(key);
          }
        });

        setConfig(newConfig);
        setLoading(false);
      } catch (err) {
        if (isMounted) {
          setError(err);
          setLoading(false);
        }
      }
    };

    loadRemoteConfig();

    const unsubscribe = remoteConfigService.onConfigChange(() => {
      if (isMounted) {
        loadRemoteConfig();
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [keysString]);

  return {config, loading, error};
};
